/* eslint-disable import/prefer-default-export */
export const USER_OBJECT = 'USER_OBJECT';
export const USER_PLUGGTO_TOKENS = 'USER_PLUGGTO_TOKENS';
export const USER_APP_TOKEN = 'USER_APP_TOKEN';
export const SET_PLUGGTOCODE = 'SET_PLUGGTOCODE';

export const FILTER_VISIBLE = 'FILTER_VISIBLE';
export const FILTER_PARAMS = 'FILTER_PARAMS';

// O pedido que esta sendo exibido no momento
export const ORDER_OBJECT = 'ORDER_OBJECT';
// Remove o pedido que este sendo visualizado do objeto principal
export const REMOVE_ORDER_OBJECT = 'REMOVE_ORDER_OBJECT';
// Adiciona uma nova entrega para o pedido
export const ADD_NEW_SHIPMENT_ORDER = 'ADD_NEW_SHIPMENT_ORDER';
// Salva as informações da entrega para o pedido
export const SAVE_SHIPMENT_INFO = 'SAVE_SHIPMENT_INFO';
// Delete a entrega que foi iniciada mas não concluida
export const CANCEL_SHIPMENT_INFO = 'CANCEL_SHIPMENT_INFO';
// Adiciona um novo item ao pedido
export const ADD_NEW_ITEM = 'ADD_NEW_ITEM';
// Atualiza dados do pedido
export const UPDATE_ORDER = 'UPDATE_ORDER';
// verifica se o pedido está sendo exibido
export const ORDER_SHOWING = 'ORDER_SHOWING';

// Action para incluir o ID de um pedido na lista em que sera usada para executar ações.
export const ADD_ORDER_TO_ACTION_LIST = 'ADD_ORDER_TO_ACTION_LIST';
// Remove todos os ids do state de action
export const CLEAN_ACTION_LIST = 'CLEAN_ACTION_LIST';


// WEBPACK FOOTER //
// ./resources/assets/js/vuex/mutation-types.js